(function () {
    'use strict';
    angular
        .module('app')
        .controller('msgBox', msgBox);
    msgBox.$inject = ['$rootScope', '$scope', 'loginService'];
    function msgBox($rootScope, scope, loginService) {
        scope.loginService = loginService;
        function activate() { }
        activate();
    }
})();
